import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';

import { SigninComponent } from './signin/signin.component';
import { LoginComponent } from './login/login.component';
import { AuthRouteModule } from './auth.route.module';
import { VersionComponent } from './version/version.component';

import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { MaintenanceStatusComponent } from './maintenance/maintenance-status/maintenance-status.component';
import { VaultreLoginComponent } from './vaultre-login/vaultre-login.component';
import { DomainLoginComponent } from './domain-login/domain-login.component';

@NgModule({
  declarations: [
    SigninComponent,
    LoginComponent,
    VersionComponent,
    AutoLoginComponent,
    MaintenanceComponent,
    MaintenanceStatusComponent,
    VaultreLoginComponent,
    DomainLoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthRouteModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.rectangleBounce,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0.3)',
      backdropBorderRadius: '0',
      primaryColour: '#FFF',
      secondaryColour: '#FFF',
      tertiaryColour: '#FFF'
    }),
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts